<div class="container">
  <ion-card class="flex-space-between" style="padding: 3px; margin: 0 14px">
    <ion-input
      #searchInput
      [placeholder]="
        authService.isAiFeatureEnabled('suggestResponses') ? '✨ Search or ask your docs' : 'Search for articles'
      "
      [(ngModel)]="searchText"
      (ionChange)="handleFilters()"
      (keyup.enter)="askAi(searchText)"
      style="border-radius: var(--input-border-radius)"
    >
    </ion-input>
  </ion-card>
  <div *ngIf="customQuery">
    <ion-button fill="clear" size="block" class="btn-large" (click)="clearAiQuery()">
      <ion-icon name="close-outline" class="padded-icon"></ion-icon>
      Clear query
    </ion-button>
    <div class="ai-text">
      {{ customQuery }}
    </div>
    <div class="ai-text" style="background: var(--ion-color-step-0)">
      <div *ngIf="!aiResponse">
        <ion-skeleton-text [animated]="true" style="width: 90%; margin-bottom: 5px"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 70%; margin-bottom: 5px"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 80%; margin-bottom: 5px"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 40%; margin-bottom: 5px"></ion-skeleton-text>
      </div>
      {{ aiResponse }}
      <div [hidden]="!isAiResponseTypedOut" style="margin: 15px 0 5px 0">
        <ion-button
          color="dark"
          fill="clear"
          class="item-accessory-button button-dark-border"
          ngxTippy
          data-tippy-content="Add to draft response"
          (click)="useAiResponse()"
          style="width: 112px; margin-left: 0"
        >
          <ion-icon name="create-outline" style="margin-right: 5px"> </ion-icon>
          <span style="font-size: 0.8rem; margin: 0 3px">Compose</span>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="item-accessory-button button-dark-border"
          ngxTippy
          data-tippy-content="Copy to clipboard"
          (click)="copyAiResponse()"
        >
          <ion-icon name="copy-outline"> </ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="item-accessory-button button-dark-border"
          ngxTippy
          data-tippy-content="Refresh AI response"
          (click)="askAi(customQuery)"
        >
          <ion-icon name="refresh-outline"> </ion-icon>
        </ion-button>
      </div>
    </div>
    <div *ngIf="aiLinks?.length">
      <div class="ai-text">
        <h3 style="margin-bottom: 0; font-size: 0.9rem">
          <ion-icon name="link-outline" class="padded-icon"></ion-icon>
          Related articles
        </h3>
      </div>
      <ion-list class="no-padding transparent-bg">
        <ion-item *ngFor="let link of aiLinks" (click)="selectUrl(link.url)" class="ion-item-rounded" button="true">
          <ion-label text-wrap>
            <h3 style="font-weight: 600; font-size: 0.8rem">
              {{ link.title }}
            </h3>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>

  <div [hidden]="customQuery" style="padding: 5px" [ngClass]="{ 'list-hidden': !!articleId }">
    <ion-list class="no-padding transparent-bg" *ngIf="authService.isAiFeatureEnabled('suggestResponses')">
      <ion-item
        class="ion-item-rounded"
        button="true"
        *ngIf="searchText?.length"
        (click)="askAi(searchText)"
        style="margin-bottom: 0"
      >
        <ion-label style="max-width: 28px">
          <p style="font-size: 1.1rem">✨</p>
        </ion-label>
        <ion-label>
          <h3><strong>Ask AI:</strong> {{ searchText }}</h3>
          <p>Hit enter to get result</p>
        </ion-label>
      </ion-item>
    </ion-list>
    <div
      class="empty-state-container"
      style="margin: 80px 0"
      [hidden]="filteredKnowledgeBaseArticles?.length || isLoading"
    >
      <span class="placeholder-emoji">
        <ion-icon name="book-outline"></ion-icon>
      </span>
      <h1 class="placeholder-title">No articles found</h1>
    </div>
    <div class="empty-state-container" *ngIf="isLoading">
      <div style="padding: 18px">
        <ion-skeleton-text [animated]="true" style="width: 50%; margin: 5px 0"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 80%; margin: 5px 0"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 90%; margin: 5px 0"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 70%; margin: 5px 0"></ion-skeleton-text>
      </div>
      <div style="padding: 18px">
        <ion-skeleton-text [animated]="true" style="width: 50%"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 90%"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 70%"></ion-skeleton-text>
      </div>
      <div style="padding: 18px">
        <ion-skeleton-text [animated]="true" style="width: 50%"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 70%"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 90%"></ion-skeleton-text>
        <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
      </div>
    </div>
    <ion-list class="no-padding transparent-bg">
      <ion-item
        *ngFor="let article of filteredKnowledgeBaseArticles; let i = index"
        (click)="selectArticle(article)"
        class="ion-item-rounded"
        button="true"
      >
        <ion-label text-wrap>
          <h3 style="margin-bottom: 6px; font-weight: 600">
            {{ article.title }}
          </h3>
          <p style="max-height: 3.9em; line-height: 1.3em">
            {{ getContentSubstring(article.content) }}
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-button (click)="manageKb()" fill="clear" color="dark" *ngIf="authService.isTenantAdmin">
      <ion-icon name="book-outline"></ion-icon>
      <span class="text-with-left-icon">Manage docs</span>
    </ion-button>
  </div>
  <div class="article-details flex-space-between flexed-align-center" [ngClass]="{ 'article-shown': !!articleId }">
    <div *ngIf="articleId">
      <ion-button fill="clear" color="dark" (click)="deselectArticle()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
      <div style="padding: 0 10px">
        <h3 style="margin: 6px 5px; font-size: 1.2rem">
          {{ article.title }}
        </h3>
        <ion-button
          color="dark"
          fill="clear"
          class="item-accessory-button button-dark-border"
          (click)="copyLink()"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            touch: false,
            placement: 'bottom',
            content: 'Copy link to clipboard'
          }"
        >
          <ion-icon name="link-outline"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="item-accessory-button button-dark-border"
          (click)="useKbArticleContent(article)"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            touch: false,
            placement: 'bottom',
            content: 'Insert formatted link to your response'
          }"
        >
          <ion-icon name="add-outline"></ion-icon>
        </ion-button>
        <ion-button
          color="dark"
          fill="clear"
          class="item-accessory-button button-dark-border"
          href="{{ article.url }}"
          target="_blank"
          ngxTippy
          [tippyProps]="{
            arrow: false,
            touch: false,
            placement: 'bottom',
            content: 'Open article in new tab'
          }"
          *ngIf="article.url"
        >
          <ion-icon name="open-outline"></ion-icon>
        </ion-button>
        <div style="margin: 10px 5px" [innerHTML]="articleContent"></div>
      </div>
      <ion-button fill="clear" (click)="editArticle(article)" class="btn-small" style="margin: 10px 0">
        <ion-icon name="create-outline" class="padded-icon"></ion-icon>
        Edit
      </ion-button>
    </div>
  </div>
</div>
